import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  hasText?: boolean;
  moreWidth?: boolean;
}

const UploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  hasText,
  moreWidth,
}) => {
  const settingsApplied = Boolean(
    image.divider !== 'none' ||
      image.brakes ||
      image.fontSize ||
      getWatermarkTag(image) !== 'none' ||
      image.authorName ||
      (image.nameColor && image.nameColor !== 'black') ||
      (image.channelImageOption && image.channelImageOption !== 'custom'),
  );

  const imgWidth = moreWidth ? 134 : 61;

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showText={!!hasText}
      showSettings={true}
      showPreview={false}
      aspectRatio={1078 / 710}
      imgRatioX={imgWidth}
      imgRatioY={64}
      textDebounceDelay={300}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          imageIndex={imageIndex}
          setImages={setImages}
          image={image}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(UploadedImageRow);
